import { render } from "./garment.vue?vue&type=template&id=5cd4dae1&ts=true"
import script from "./garment.vue?vue&type=script&lang=ts"
export * from "./garment.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__